// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"10201":"4-feat-protobuf-root","26996":"4-auth-msal","88491":"2-polyfill-idle"}[chunkId] || chunkId) + ".js";
};